<template>
  <transition name="modal">
    <div class="modal-mask" @click="closeOnClickMask ? close() : ''">
      <div class="modal-wrapper">
        <div id="dynamic-modal-container"
             class="modal-container"
             @click.stop
             :style="styleContainer"
        >
          <div class="modal-header">
            <h5>
              <slot name="title"></slot>
            </h5>
            <span class="inline-group">
              <slot name="header"></slot>
            </span>
            <button v-if="allowedClose" id="button-close-modal" type="button" class="close" @click="close"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" :style="styleBody">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Modal',
    inject: ['$validator'],
    props: {
      allowedClose: { default: true, required: false, type: Boolean, docString: 'allows to close the modal' },
      bodyOverflowY: { default: 'auto', required: false, type: String, docString: 'overflow-y for div modal-body' },
      closeOnClickMask: { default: true, required: false, type: Boolean, docString: 'close modal on click modal mask' },
      width: { required: false, default: 550 }
    },
    methods: {
      close: function () {
        if (this.allowedClose) {
          this.$emit('close')
        }
      },
      pressKey: function (e) {
        if (e.keyCode === 27) {
          this.close()
        }
      }
    },
    computed: {
      styleBody: function () {
        return {
          'overflow-y' : this.bodyOverflowY
        }
      },
      styleContainer: function () {
        return {
          'max-width': `${this.width}px`
        }
      }
    },
    beforeDestroy () {
      if (this.allowedClose) { document.body.removeEventListener('keyup', this.pressKey) }
    },
    mounted () {
      if (this.allowedClose) { document.body.addEventListener('keyup', this.pressKey) }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--color-overlay-50);
    display: table;
    transition: opacity .3s ease;
  }
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  .modal-body {
    overflow-y: auto;
    max-height: 75vh;
  }
  .modal-container {
    border: 1px solid var(--color-overlay-20);
    border-radius: .3rem;
    margin: 0 auto;
    background-color: var(--color-surface);
    color: var(--color-onSurface);
    box-shadow: var(--z-1);
    transition: all .3s ease;
    max-height: 95vh;
  }
  .modal-default-button {
    float: right;
  }
  .modal-enter {
    opacity: 0;
  }
  .modal-leave-active {
    opacity: 0;
  }
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .modal-header h5 {
    margin: 0;
  }
  @media (max-width: 750px) {
    .modal-container {
      width: 98%;
    }
  }
</style>

<style lang="sass">
.modal-header
  font-size: 1rem
  font-weight: 400
  line-height: 1.5
  text-align: left
  color: var(--color-onSurface)
  box-sizing: border-box
  display: flex
  -webkit-box-align: start
  align-items: flex-start
  -webkit-box-pack: justify
  justify-content: space-between
  padding: 1rem 1rem
  border-bottom: 1px solid #dee2e6
  border-top-left-radius: .3rem
  border-top-right-radius: .3rem
.modal-footer
  font-size: 1rem
  font-weight: 400
  line-height: 1.5
  text-align: left
  color: var(--color-onSurface)
  box-sizing: border-box
  display: flex
  -webkit-box-align: center
  align-items: center
  -webkit-box-pack: end
  justify-content: flex-end
  padding: 1rem
  border-top: 1px solid #dee2e6
  border-bottom-right-radius: .3rem
  border-bottom-left-radius: .3rem
.close
  box-sizing: border-box
  border-radius: 0
  font-family: inherit
  overflow: visible
  text-transform: none
  float: right
  font-size: 1.5rem
  font-weight: 700
  line-height: 1
  color: #000
  text-shadow: 0 1px 0 #fff
  opacity: .5
  background-color: transparent
  border: 0
  appearance: none
  cursor: pointer
  padding: 1rem 1rem
  margin: -1rem -1rem -1rem auto
  outline: none
</style>
